import * as yup from "yup";

export default function useOrderSchemaCreate({ userMe }) {
  const OrderSchema = yup.object().shape({
    products: yup.array().of(
      yup.object().shape({
        productModel: yup
          .object()
          .shape({
            value: yup.string().typeError("Vui lòng chọn dung tích").required("Vui lòng chọn dung tích"),
          })
          .required("Vui lòng chọn dung tích"),

        product: yup
          .object()
          .shape({
            value: yup.string().typeError("Vui lòng chọn sản phẩm").required("Vui lòng chọn sản phẩm"),
          })
          .required("Vui lòng chọn sản phẩm"),

        qty: yup
          .number()
          .typeError("Vui lòng nhập số lượng")
          .required("Vui lòng nhập số lượng")
          .min(1, "Số lượng phải lớn hơn 0")
          .test("qty-less-than-stock", "Số lượng phải nhỏ hơn tồn kho khả dụng", function checkQtyLessThanStock(value) {
            const stockQty = Number(this.parent?.productModel?.qty);

            if (!stockQty || !value) return true;

            return Number(value) <= stockQty;
          }),

        discount: yup.number(),
      }),
    ),

    customer: yup
      .object()
      .shape({
        value: yup.string().typeError("Vui lòng chọn khách hàng").required("Vui lòng chọn khách hàng"),
      })
      .required("Vui lòng chọn khách hàng"),

    warehouse: yup
      .object()
      .nullable()
      .when("adminRole", {
        is: true,
        then: (schema) =>
          schema.required("Vui lòng chọn kho").shape({
            value: yup.string().typeError("Vui lòng chọn kho").required("Vui lòng chọn kho"),
          }),
        otherwise: (schema) => schema.nullable(),
      }),

    childWarehouse: yup.object().nullable().notRequired(),

    paymentMethod: yup
      .object()
      .shape({
        value: yup.string().typeError("Vui lòng chọn phương thức thanh toán").required("Vui lòng chọn phương thức thanh toán"),
      })
      .required("Vui lòng chọn phương thức thanh toán"),

    recipient: yup
      .object()
      .shape({
        _id: yup.string().typeError("Vui lòng chọn người nhận").required("Vui lòng chọn người nhận"),
      })
      .required("Vui lòng chọn người nhận"),

    cod: yup.number().typeError("Vui lòng nhập phí COD").required("Vui lòng nhập phí COD").min(0, "Phí COD phải lớn hơn 0"),

    note: yup.string().nullable().max(500, "Không nhập quá 500 ký tự"),

    pickUpType: yup.string().required("Vui lòng chọn phương thức lấy hàng"),

    pickupDate: yup.string().required("Vui lòng chọn ngày lấy hàng"),

    adminRole: yup.boolean(),
  });

  const OrderDefault = {
    products: [
      {
        productModel: null,
        product: null,
        qty: 1,
        discount: 0,
      },
    ],
    shippingFee: 0,
    hasCOD: "noCOD",
    cod: 0,
    note: "",
    pickUpAddress: "",
    pickUpType: "",
    pickupDate: null,
    customer: null,
    warehouse: null,
    childWarehouse: null,
    paymentMethod: null,
    shippingProvider: null,
    recipient: null,
    adminRole: false,
  };

  return {
    OrderDefault,
    OrderSchema,
  };
}
